import { Grid } from '@material-ui/core';
import ResolutionsProvider from './ResolutionsContext';
import ServiceOrders from './ServiceOrders';
import CustomerOrders from './CustomerOrders';
import ManualResolutions from './ManualResolutions';
import MagicDates from './MagicDates';
import DefectiveComponents from './DefectiveComponents';

interface IProps {
    ticketId: string
    isReadOnly: boolean
}

let Resolutions = (props: IProps) => {
    return (
        <Grid container>
            <ResolutionsProvider ticketId={props.ticketId}>
                <ServiceOrders isReadOnly={props.isReadOnly} />
                <CustomerOrders isReadOnly={props.isReadOnly} />
                <ManualResolutions isReadOnly={props.isReadOnly} />
                <DefectiveComponents isReadOnly={props.isReadOnly} />
                <MagicDates/>
            </ResolutionsProvider>
        </Grid>
    )
}

export default Resolutions;